import type { PowerpointStaticContent } from '@core-api/editor/types/response';
import { usePresentationSlideContext } from '../../legacy-context/presentationContext';
import { EmbedIntegrationPresentation } from '../../shared/components/embed-integrations/EmbedIntegrationPresentation';
import { buildPowerpointSlidesURL, isValidPowerpointSlidesURL } from './utils';

export function PowerpointPresentation() {
  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as PowerpointStaticContent;

  return (
    <EmbedIntegrationPresentation
      integrationName="PowerPoint"
      presentationUrl={buildPowerpointSlidesURL(
        staticContent.url,
        staticContent.startingSlideNumber ?? 1,
      )}
      isValidUrl={isValidPowerpointSlidesURL}
      focusNoticeEnabled={true}
    />
  );
}
